import { Input } from "@chakra-ui/react";
import { Fragment } from "react";
import { Control, Controller } from "react-hook-form";
import { useGetConverterTypes } from "@/core/convertersTypes/useCases/useGetConverterType";
import { useGetStorage } from "@/core/storages/useCases/useGetStorage";
import { useAuth } from "@/shared/session";
import { Field } from "@/ui/chakra/field";
import { NativeSelectField, NativeSelectRoot } from "@/ui/chakra/native-select";

interface ProductFormProps {
  control: Control;
}

const ProductForm: React.FC<ProductFormProps> = ({ control }) => {
  const { session } = useAuth();
  const { data: converterTypes } = useGetConverterTypes();
  const { data: storages } = useGetStorage(session?.zone || "");
  return (
    <Fragment>
      <Controller
        control={control}
        name="description"
        render={({ field, fieldState: { invalid, error } }) => (
          <Field
            label="Descripcion"
            required
            invalid={invalid}
            errorText={error?.message}
          >
            <Input
              type="text"
              placeholder="Descripcion del producto"
              {...field}
            />
          </Field>
        )}
      />

      <Controller
        control={control}
        name="unit"
        render={({ field, fieldState: { invalid, error } }) => (
          <Field
            label="Unidad"
            required
            invalid={invalid}
            errorText={error?.message}
          >
            <Input type="text" placeholder="Unidad del producto" {...field} />
          </Field>
        )}
      />

      <Controller
        control={control}
        name="location"
        render={({ field, fieldState: { invalid, error } }) => (
          <Field label="Ubicacion" invalid={invalid} errorText={error?.message}>
            <Input
              type="text"
              placeholder="Ubicacion del producto"
              {...field}
            />
          </Field>
        )}
      />

      <Controller
        control={control}
        name="stock"
        render={({ field, fieldState: { invalid, error } }) => (
          <Field
            label="Stock inicial"
            required
            invalid={invalid}
            errorText={error?.message}
          >
            <Input type="number" placeholder="Stock del producto" {...field} />
          </Field>
        )}
      />

      <Controller
        control={control}
        name="minimumStock"
        render={({ field, fieldState: { invalid, error } }) => (
          <Field
            label="Stock mínimo"
            invalid={invalid}
            errorText={error?.message}
          >
            <Input
              type="number"
              placeholder="Stock minimo del producto"
              {...field}
            />
          </Field>
        )}
      />

      <Controller
        control={control}
        name="converter"
        render={({ field, fieldState: { invalid, error } }) => (
          <Field
            label="Convertidor"
            invalid={invalid}
            errorText={error?.message}
          >
            <Input type="text" placeholder="Convertidor" {...field} />
          </Field>
        )}
      />

      <Controller
        control={control}
        name="converterTypeId"
        render={({ field, fieldState: { invalid, error } }) => (
          <Field
            label="Tipo de convertidor"
            invalid={invalid}
            errorText={error?.message}
          >
            <NativeSelectRoot>
              <NativeSelectField
                placeholder="Seleccione un tipo de convertidor"
                {...field}
              >
                {converterTypes?.map((converterType) => (
                  <option key={converterType.id} value={converterType.id}>
                    {converterType.name}
                  </option>
                ))}
              </NativeSelectField>
            </NativeSelectRoot>
          </Field>
        )}
      />

      <Controller
        control={control}
        name="storageId"
        render={({ field, fieldState: { invalid, error } }) => (
          <Field
            label="Bodega"
            required
            invalid={invalid}
            errorText={error?.message}
          >
            <NativeSelectRoot>
              <NativeSelectField placeholder="Seleccione una bodega" {...field}>
                {storages?.map((storage) => (
                  <option key={storage.id} value={storage.id}>
                    {storage.name}
                  </option>
                ))}
              </NativeSelectField>
            </NativeSelectRoot>
          </Field>
        )}
      />
    </Fragment>
  );
};

export default ProductForm;
